import * as swcHelpers from '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';
import { useSubscribeNewsletter } from './use-subscribe-newsletter.js';

const useBloomreachNewsletterData = ()=>{
    var ref, ref1;
    const newsletterSubscribe = useSubscribeNewsletter();
    /**
   * Get the newsletter content from the BR Newsletter content model
   */ const page = useBrPageContext();
    const pageModels = useBloomreachPageModels();
    const newsletterContent = getBrPageContent(page, pageModels === null || pageModels === void 0 ? void 0 : pageModels.newsletterConfiguration);
    const contentAfterSubmit = newsletterContent === null || newsletterContent === void 0 ? void 0 : (ref = newsletterContent.richTextAfter) === null || ref === void 0 ? void 0 : ref.value;
    const contentBeforeSubmit = newsletterContent === null || newsletterContent === void 0 ? void 0 : (ref1 = newsletterContent.richTextBefore) === null || ref1 === void 0 ? void 0 : ref1.value;
    const title = newsletterContent === null || newsletterContent === void 0 ? void 0 : newsletterContent.title;
    return swcHelpers.objectSpread({}, newsletterSubscribe, {
        contentAfterSubmit,
        contentBeforeSubmit,
        title
    });
};

export { useBloomreachNewsletterData };
//# sourceMappingURL=use-bloomreach-newsletter-data.js.map
